import noop from '@anm/helpers/noop';
import { useCallback } from 'react';

import { UseLoadMoreProps } from '../types';

export const useLoadMore = ({
  currentPage,
  onLoadMore = noop
}: UseLoadMoreProps) => {
  const handleLoadMore = useCallback(() => {
    const newPageNumber = currentPage + 1;

    onLoadMore(newPageNumber);
  }, [onLoadMore, currentPage]);

  return handleLoadMore;
};
